export default __webpack_public_path__ + "static/media/portfolio3.6499c3aa.jpg";